import { render, staticRenderFns } from "./import-evalutor.vue?vue&type=template&id=20b88249&"
import script from "./import-evalutor.vue?vue&type=script&lang=js&"
export * from "./import-evalutor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports